import React, { useState } from "react";
import { FieldType } from "../../../services/helpers/types";
import TextArea from "../TextArea/TextArea";
import { useTranslation } from "react-i18next";

interface AddStaticTextFieldProps {
  field?: FieldType;
  onFieldChange: (name: string, value?: any) => void;
}

const AddStaticTextField = (props: AddStaticTextFieldProps) => {
  const { field, onFieldChange } = props;

  const { t } = useTranslation();

  const [defaultValue, setDefaultValue] = useState<string>(
    field?.defaultValue ?? ""
  );
  const handleDefaultValueChange = (value: string) => {
    setDefaultValue(value);
    onFieldChange("defaultValue", value);
  };
  return (
    <div>
      <div className="dui-example-field dui-example-field-static">
        <div className="dui-example-title">{t("defaultValue")}:</div>
        <TextArea value={defaultValue} onChange={handleDefaultValueChange} />
      </div>
    </div>
  );
};

export default AddStaticTextField;
